import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DiagnosticPositionComponent } from './diagnostic-position.component';
import { CardComponent } from '../../@theme/components/card/card.component';



@NgModule({
  declarations: [DiagnosticPositionComponent],
  imports: [
    CommonModule,
    CardComponent
  ],
  exports: [DiagnosticPositionComponent],
})
export class DiagnosticPositionModule { }
